import { Col, Container, Image, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player/lazy';


export default function Header({ links }) {  
  const [title1, setTitle1] = useState(true);
    const [title2, setTitle2] = useState(false);
    const [title3, setTitle3] = useState(false);

    const [video1, setVideo1] = useState(true);
    const [video2, setVideo2] = useState(false);
    const [video3, setVideo3] = useState(false);

    const title1Handler = () => {setTitle1(true); setTitle2(false); setTitle3(false); };
    const title2Handler = () => {setTitle1(false);setTitle2(true);setTitle3(false); };
    const title3Handler = () => {setTitle1(false);setTitle2(false);setTitle3(true); };

    const video1Handler = () => {setVideo1(true); setVideo2(false); setVideo3(false); };
    const video2Handler = () => {setVideo1(false);setVideo2(true);setVideo3(false); };
    const video3Handler = () => {setVideo1(false);setVideo2(false);setVideo3(true); };   
   
  return (
    <Container fluid id="header-wrapper">
     <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}cp-grid-top.png`} width="" height="50px" className="grid-top"/>   
     <Row className="text-center" >
      <Col lg={2} xl={2} className="ml-auto header-d"></Col>
        <Col sm={12} lg={2} xl={2}>
          {/* <a href='https://www.swmc.com/'
              target="_blank" rel="noreferrer noopener"
              title="https://www.swmc.com/">
            <Image
              src="https://stagingresources.swmc.com/swmc-images/TA-Images/ta-lswmc-blue-logo.png"
              fluid
              alt="Sun West Mortgage Logo"
              className="mt-5 mb-3 sunwest-logo"
              />
          </a> */}
        </Col>
      </Row>
      <Row>
          <Col lg={2} xl={2} className="ml-auto"></Col>
          <Col md={12} lg={3} xl={3} className="mt-5 mb-3">
            <div className="pt-3 mb-3 pageInfoHighlightsContainer">
            {title1 && (
              <h4 className="pageInfoHeading d-none d-lg-block d-xl-block">
                Impact of<br/><a href="https://www.angelai.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>{links.brandName}</a> on<br/>the Future of<br/>Mortgage<br/>Operations.</h4>)}
              {title2 && (
                <h4 className="pageInfoHeading d-none d-lg-block d-xl-block">
                  What <br/>is <br/><a href="https://www.angelai.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>{links.brandName}</a>?<br/><br/><br/></h4>)}
                {title3 && ( <h4 className="pageInfoHeading d-none d-lg-block d-xl-block">
                <a href="https://www.angelai.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>{links.brandName}</a><br/>Is Like a<br/>Doctor With<br/>No Waiting <br/>Time. </h4>)}

             {title1 && (<h4 className="pageInfoHeading2 d-lg-none d-xl-none d-sm-block d-xs-block">Impact of <a href="https://www.angelai.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>{links.brandName}</a> on the Future of Mortgage Operations</h4>)}
             {title2 && (<h4 className="pageInfoHeading2 d-lg-none d-xl-none d-sm-block d-xs-block">What is <a href="https://www.angelai.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>{links.brandName}</a>?</h4>)}
             {title3 && (<h4 className="pageInfoHeading2 d-lg-none d-xl-none d-sm-block d-xs-block"><a href="https://www.angelai.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>{links.brandName}</a> Is Like a Doctor With No Waiting Time.</h4>)}
                              <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-orange-bar.png`} width="" height="230px" className="orange-bar"/>              
            </div>
                                <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-star-vector.png`} width="45px" height="45px" className="star-vector-01"/>
          </Col>
          

          <Col md={12} lg={5} xl={5} style={{ marginTop: "", zIndex: "3"}}>  
          <div>       
          {video1 && (<div onClick={title1Handler}>
            <div className="player-wrapper">
            <ReactPlayer
              className="react-player"
              url="https://youtu.be/ZcOYrWT9B44"
              width="100%" height="100%"
              light={`${process.env.REACT_APP_CDN_IMAGES}ta-vid-thumb-01.webp`}
              playing con controls
              onClick={video1Handler}
            />  
             </div>
             </div> )}
             {video2 && (<div className="player-wrapper">
            <ReactPlayer
              className="react-player" url="https://youtu.be/a-SlslNjB2U"
              width="100%" height="100%" light playing con controls
            />              
             </div> )}
             {video3 && (<div className="player-wrapper">
            <ReactPlayer
              className="react-player" url="https://youtu.be/9ONDtIEUedw" width="100%" height="100%"
              light playing con controls              
            />  
             </div>)}
             <div className="waveWhite">
                  <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-podcast-wave-white.png`} width="420px" height="" className="ta-podcast-wave-white"/></div>

                <div className="waveblue">
                  <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-podcast-wave-blue.png`} width="420px" height="" className="ta-podcast-wave-blue"/></div>
          
          <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-border-right.png`} width="120px" height="" className="ta-border-right"/></div>     

                <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-star-vector.png`} width="60px" height="60x" className="star-vector-02"/>
  
              </Col>
                  
         <Row className="row2" style={{marginTop: "-9rem" , zIndex: "22"}}>
         <Col lg={2} xl={2} sm={0} xs={0} className="cl-1 ml-auto d-lg-block d-xl-block"></Col>
          <Col md={12} lg={3} xl={3} sm={0} xs={0} className="cl-2 mb-3 mt-5 d-lg-block d-xl-block">
             <div className="mtc">
              <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-play-icon.png`} width="42px" height="42px" className="play-icon-bar"/>
              <h5 className="ps-5 watch-prodcast-text">Watch podcast</h5> </div>
              <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-arrow.png`} width="150px" height="" className="arrow-bar"/>             
          </Col>
                   
          <Col md={6} sm={4} xs={4} lg={2} className="mx-lg-3 mx-xl-3 mt-3" >        
          <div onClick={title2Handler}>
            <div className="pt-1 mb-3 pageInfoHighlightsContainer"  onClick={video2Handler}>
              <Image
              loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-vid-thumb-dextop-02.webp`}
              width="350px" className="thumbnail-2" fluid
              style={{ cursor: "pointer", maxWidth: "120%"}} // onClick={()=> setShow(true)} 
              alt="" />
            </div></div>
            </Col>
          <Col md={6} sm={4} xs={4} lg={2} className="mt-3">
            <div onClick={title3Handler}>
            <div className="pt-1 mb-3 pageInfoHighlightsContainer" onClick={video3Handler}>
              <Image
              loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-vid-thumb-dextop-03.webp`}
              width="350px" className="thumbnail-3" fluid
              style={{ cursor: "pointer", maxWidth: "120%"}} // onClick={()=> setShow(true)} 
              alt="" />
            <Image loading="lazy" src={`${process.env.REACT_APP_CDN_IMAGES}ta-star-vector.png`} width="45px" height="45px" className="star-vector-03"/>
            </div></div>
          </Col>
          </Row>
          <div className="podcast-2 pt-1 mb-1"><h4 className="watchpod2">Watch podcast</h4>          
            </div>
        </Row>
    </Container>
  );
}
